import { blacks } from './blacks';

const base = {
    '50': '#e9e9e9',
    '100': '#c9c9c9',
    '200': '#a5a5a5',
    '300': '#808080',
    '400': '#656565',
    '500': '#4a4a4a',
    '600': '#434343',
    '700': '#3a3a3a',
    '800': '#323232',
    '900': '#222222'
};

const contrast = {
    '50': blacks[500],
    '100': blacks[500],
    '200': blacks[500],
    '300': blacks[500],
    '400': blacks[500],
    '500': blacks[500],
    '600': blacks[500],
    '700': blacks[500],
    '800': blacks[500],
    '900': blacks[500]
};

const alpha = {
    '50': base[50] + '1f',
    '100': base[100] + '1f',
    '200': base[200] + '1f',
    '300': base[300] + '1f',
    '400': base[400] + '1f',
    '500': base[500] + '1f',
    '600': base[600] + '1f',
    '700': base[700] + '1f',
    '800': base[800] + '1f',
    '900': base[900] + '1f'
};

export const grays = {
    '50': base[50],
    '100': base[100],
    '200': base[200],
    '300': base[300],
    '400': base[400],
    '500': base[500],
    '600': base[600],
    '700': base[700],
    '800': base[800],
    '900': base[900],
    light: base[100],
    medium: base[500],
    dark: base[900],
    contrast,
    alpha
};
